export enum ConnectContactStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
}

export enum ConnectContactChannel {
  VOICE = 'VOICE',
  VOICEMAIL = 'VOICEMAIL',
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}

export interface ConnectContactsResponse {
  rosterTotal: number;
  completedTotal: number;
  connectContacts: ConnectContactResponse[];
}

export interface ConnectContactResponse {
  id: number;
  rosterId?: number;
  status: ConnectContactStatus;
  channel: ConnectContactChannel;
  phoneNumber: string;
  completedAt: string;
  contactedAt: string;
  smsData?: ConnectContactSmsEvent[];
  voicemailTranscript?: string;
  agentId?: string;
  emailSubject?: string;
  emailSender?: string;
  emailThreadId?: string;
  emailInboxId?: string;
  emailNotificationReason?: string;
  client: ConnectContactClient;
}

export interface ConnectContactSmsEvent {
  timestamp: string;
  role: ConnectContactSmsEventRole;
  content: string;
  senderId?: string;
  senderName?: string;
  senderEmail?: string;
  senderImage?: string;
}

export enum ConnectContactSmsEventRole {
  CUSTOMER = 'CUSTOMER',
  AGENT = 'AGENT',
  BOT = 'BOT',
}

export interface SmsThreadResponse {
  patientPhoneNumber: string;
  connectPhoneNumber: string;
  client?: SmsThreadClient;
  // The most recent contact in the thread -- the target the next reply is sent against.
  latestContactId?: string;
  messages: ConnectContactSmsEvent[];
}

export interface SmsThreadClient {
  publicPatientId?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
}

export interface SmsReplyRequest {
  contactId: number;
  body: string;
}

// Reason returned with a 409 when a reply cannot be sent because a session is currently open.
export const SMS_CONVERSATION_ACTIVE = 'CONVERSATION_ACTIVE';

interface ConnectContactClient {
  publicPatientId?: string;
  firstName: string;
  middleName: string;
  lastName: string;
}

export enum ConnectContactAssociateResult {
  COMPLETE = 'COMPLETE',
  COMPLETE_BUT_CODE_BINDING_MISSING = 'COMPLETE_BUT_CODE_BINDING_MISSING',
  COMPLETE_BUT_PHONE_FIELDS_SLOTS_MISSING = 'COMPLETE_BUT_PHONE_FIELDS_SLOTS_MISSING',
  FAILED = 'FAILED',
}

export interface ConnectContactAssociateResponse {
  result: ConnectContactAssociateResult;
}

export interface QueueMappingResponse {
  queueId: string;
  queueName: string;
  roster: {
    id: number;
    name: string;
  };
}

export interface AvailableQueue {
  queueId: string;
  queueName: string;
  rostersIds: number[];
}

export interface VoicemailCampaignSummary {
  id?: number;
  name?: string;
}

export interface CampaignConfigResponse {
  id: number;
  rosterId: number;
  rosterName: string;
  campaignId: string;
  active: boolean;
  voicemailConfig?: VoicemailCampaignSummary;
  createdAt: string;
  updatedAt: string;
}

export interface CampaignConfigCreateRequest {
  rosterId: number;
  campaignId: string;
  voicemailConfigId?: number | null;
}

export interface CampaignConfigUpdateRequest {
  campaignId?: string;
  active?: boolean;
  voicemailConfigId?: number | null;
}

export interface VoicemailConfigResponse {
  id: number;
  name: string;
  voicemailOnAttempts: number[];
  voicemailTemplate: string;
  voicemailTemplateFallback: string;
  followupAfterAttempt: number;
  voicemailTemplateFollowup: string;
  voicemailTemplateFollowupFallback: string;
  practiceName: string;
  callbackNumber: string;
  callerPersonaName: string;
  usedBy: number;
}

export interface VoicemailConfigRequest {
  name: string;
  voicemailOnAttempts: number[];
  voicemailTemplate: string;
  voicemailTemplateFallback: string;
  followupAfterAttempt: number;
  voicemailTemplateFollowup: string;
  voicemailTemplateFollowupFallback: string;
  practiceName: string;
  callerPersonaName: string;
  callbackNumber: string;
}
